import { ReactNode } from "react";

interface HeaderProps {
  title: string;
  subtitle?: string;
  style?: string;
  leftIcon?: ReactNode;
  rightContent?: ReactNode;
  rightContentStyle?: string;
}

export default function Header({
  title,
  subtitle,
  leftIcon,
  style,
  rightContent,
  rightContentStyle,
}: HeaderProps) {
  return (
    <div
      className={
        "pt-8 pb-6 px-4 space-y-6 divide-y w-full border-b border-slate-200" +
        (style ? style : "")
      }
    >
      <div className="flex pl-4 pr-4 justify-between items-center ">
        <div className="flex items-center ">
          {leftIcon && leftIcon}
          <div className="flex-shrink-0">
            <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
            {subtitle && (
              <p className="mt-1 max-w-2xl text-sm text-gray-500">{subtitle}</p>
            )}
          </div>
        </div>

        {rightContent && (
          <div className={rightContentStyle}>{rightContent}</div>
        )}
      </div>
    </div>
  );
}
